import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
const DefaultTextPropsContext = createContext({
  tone: void 0,
  weight: void 0,
  size: void 0
});
const DefaultTextPropsProvider = ({
  size,
  weight,
  tone,
  children
}) => {
  const defaultTextProps = useMemo(
    () => ({
      size,
      weight,
      tone
    }),
    [size, weight, tone]
  );
  return /* @__PURE__ */ jsx(DefaultTextPropsContext.Provider, { value: defaultTextProps, children });
};
const useDefaultTextProps = ({
  size: sizeProp,
  weight: weightProp,
  tone: toneProp
}) => {
  const { size, weight, tone } = useContext(DefaultTextPropsContext);
  return {
    size: sizeProp ?? size ?? "standard",
    weight: weightProp ?? weight ?? "regular",
    tone: toneProp ?? tone ?? "neutral"
  };
};
export {
  DefaultTextPropsProvider,
  useDefaultTextProps
};
